import React from 'react'
import {compose, lifecycle, withState} from 'recompose'
import Swiper from 'swiper/dist/js/swiper.js';
import '../../node_modules/swiper/dist/css/swiper.min.css'

function CustomizedSwiper({list, guid}) {
  return (
    <div className={guid}>
      <div className="swiper-container" style={{paddingBottom: 30}}>
        <div className="swiper-wrapper">
          {list.map((element, i) => {
            return (
              <div key={i} className="swiper-slide">{element}</div>
            )
          })}
        </div>
        <div className="swiper-pagination"/>
      </div>
    </div>
  )
}

export default compose(
  withState('guid', 'setGuid', ''),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (prevProps.list !== this.props.list) {
        //load(this.props.setGuid, this.props.options || {}, this.props.onSlideChange)
      }
    },
    componentDidMount() {
      load(this.props.setGuid, this.props.options || {}, this.props.onSlideChange)
    }
  })
)
(CustomizedSwiper)

function load(setGuid, options, onSlideChange) {
  function genGuid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return 'x' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  const guid = genGuid();
  setGuid(guid)
  setTimeout(() => {
    const swiper = new Swiper(`.${guid} .swiper-container`, {
      slidesPerView: 1,
      spaceBetween: 30,
      pagination: {
        el: `.${guid} .swiper-pagination`,
        clickable: true,
      },
      ...options,
    })
    onSlideChange && swiper.on('slideChange', () => {
      onSlideChange(swiper.activeIndex)
    });
  }, 0)
}



// WEBPACK FOOTER //
// ./src/basic/CustomizedSwiper.js